/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { User } from '../../../../types';
import { AuthState } from '../../state/authState.state';
import { Observable } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'dash-gis-logout-dialog',
    templateUrl: './logout-dialog.component.html',
})
export class LogoutDialogComponent {
    @Select(AuthState.user)
    public user$: Observable<User>;

    constructor(private store: Store, private dialogRef: MatDialogRef<LogoutDialogComponent>) {}

    public logout() {
        // this.store.dispatch(new BeginLogout());
        this.dialogRef.close(true);
    }
}
